import { S_TitleWrapper } from './style';

const Title = () => {
  return <S_TitleWrapper>회원가입</S_TitleWrapper>;
};

export default Title;
